@if (activeID > 0) {
  <div id="submodule-affiliation" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel -->
      <h2>{{ 'SHARED.AFFILIATION.TITLE.MAIN' | translate }}</h2>
      <!-- Toolbar -->
      <phscw-toolbar
        componentIdentifier="entityAffiliation"
        [componentConnection]="$any(this)"
        [buttonAdd]="allowNewAffiliation && !editMode"
        buttonAddChildTooltip="{{ 'SHARED.AFFILIATION.TITLE.ADD' | translate }}"
        >
      </phscw-toolbar>
    </div>
    <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
    <!-- Listen der Verknüpfungen -->
    @if ( !loading && !editMode && dataExists) {
      <!-- Grids -->
      @if (parentsData && parentsData.length && !loading) {
        <div>
          <p class = "cw-table-heading">{{ 'SHARED.AFFILIATION.TITLE.PARENT' | translate }}</p>
          <phscw-grid
            #gridParentEntityAffiliation
            gridId="parentEntityAffiliation"
            [simpleGrid]="true"
            [gridData]="parentsData"
            [gridColumns]="gridColumns"
            [gridDisplayedColumns]="gridParentDisplayedColumns"
            >
          </phscw-grid>
        </div>
      }
      @if (childrenData && childrenData.length && !loading) {
        <div>
          <p class = "cw-table-heading">{{ 'SHARED.AFFILIATION.TITLE.CHILD' | translate }}</p>
          <phscw-grid
            #gridChildEntityAffiliation
            gridId="childEntityAffiliation"
            [simpleGrid]="true"
            [gridData]="childrenData"
            [gridColumns]="gridColumns"
            [gridDisplayedColumns]="gridChildDisplayedColumns"
            >
          </phscw-grid>
        </div>
      }
      @if (partnerData && partnerData.length && !loading) {
        <div>
          <p class = "cw-table-heading">{{ 'SHARED.AFFILIATION.TITLE.PARTNER' | translate }}</p>
          <phscw-grid
            #gridPartnerEntityAffiliation
            gridId="partnerEntityAffiliation"
            [simpleGrid]="true"
            [gridData]="partnerData"
            [gridColumns]="gridColumns"
            [gridDisplayedColumns]="gridPartnerDisplayedColumns"
            >
          </phscw-grid>
        </div>
      }
    }
    @if ( !loading && editMode) {
      <phscw-entity-affiliation-form
        [currentEntityId]="activeID"
        [currentEntityType]="entityType"
        [(editMode)]="editMode"
        (editModeChange)="onEditModeChange($event)">
      ></phscw-entity-affiliation-form>
    }
    <!-- Hinweis über Nichtfinden der Daten -->
    @if ( !loading && !editMode && !dataExists) {
      <div>
        <p>{{ 'GENERAL.NODATA' | translate }}</p>
      </div>
    }
  </div>
}
